
class Login extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.recoveryForm = this.element.querySelector("#recover_form");
    this.loginForm = this.element.querySelector("#login");

    this.submitButton = this.element.querySelector('.account-register__button');
    if(this.submitButton) this.submitButton.disabled = true;

    if (window.location.href.indexOf("recover") != -1) {
      this.openRecover();
    }

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-recovery"]',
      this.toggleRecovery.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="submit-input-login"]',
      this.submitLoginForm.bind(this)
    );

    this.delegateElement.on(
      "click",
      ".customer-address__default-checkbox-wrapper",
      this.toggleSubmitButtonBasedOnCheckbox.bind(this)
    );
  }

  openRecover() {
    if (event) {
      event.preventDefault();
    }

    this.recoveryForm.setAttribute('aria-visible', 'true');
    this.loginForm.setAttribute('aria-visible', 'false');

  }

  toggleRecovery(event) {
    event.preventDefault();
    const id = event.target.dataset.id;

    if (id === "recover") {
      this.element.querySelector("#recover_form").setAttribute("aria-visible", "true");
      this.element.querySelector("#login").setAttribute("aria-visible", "false");
      history.pushState(null, "", "#recover_form"); // Add #recover_form to URL
    } else {
      this.element.querySelector("#recover_form").setAttribute("aria-visible", "false");
      this.element.querySelector("#login").setAttribute("aria-visible", "true");
      history.pushState(null, "", " "); // Remove #recover_form from URL
    }
  }

  submitLoginForm(e) {
    if (e.key === "Enter") {
      event.preventDefault();
      this.element.querySelector("#customer_login")?.submit();
    }
  }

  toggleSubmitButtonBasedOnCheckbox() {
    const checkbox = this.element.querySelector('#address_default');
    const submitButton = this.element.querySelector('.account-register__button');

    if (!checkbox || !submitButton) return;

    submitButton.disabled = checkbox.checked;
  }
}

customElements.define("customer-pages", Login);


class AccountComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    const allDrawer = this.element.querySelectorAll('.account__inner-drawer');

    console.log("all drawer: ", allDrawer)

    allDrawer.forEach((drawer) => {
      new Drawer(drawer);
    });

    new Popup(this.element);

    this.accountHeader = this.element.querySelector('.customerAccount--Header');
    this.accountHeaderDivider = this.element.querySelector('.acc__divider--customer');

    this.bindEvents();
    this.handleRefreshState();

  }
  bindEvents() {

    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-subtab"]', this.toggleSubTab.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-back"]', this.toggleBack.bind(this));
    this.delegateElement.on("click", '[data-action="delete-address"]', this.deleteAddress.bind(this));
    this.delegateElement.on('click', '[data-action="submit-form"]', this.validateCountry.bind(this));
  }

  validateCountry(e) {
    const form = e.target.closest('form');
    const select = form.querySelector('[name="address[country]"]');

    select.setCustomValidity('');

    // Run browser's default validations first
    if (!form.checkValidity()) return;

    // Now apply custom country check
    if (select.value === '---' || select.value === 'Country') {
      e.preventDefault();
      select.setCustomValidity('Please select a country');
      form.reportValidity(); // Show the error
    }
  }

  handleRefreshState() {
    if (responsive.matchesBreakpoint('lap_and_up') && !window.location.search) {
      this.element.querySelector('#contactInfo').setAttribute('aria-visible', 'true');
      this.element.querySelector('.customer-account__menu-tab[data-id="contactInfo"]').setAttribute("aria-expanded", "true");
    }
    // Get the URL search parameters
    var searchParams = new URLSearchParams(window.location.search);

    // Get the value of param1
    var param1Value = searchParams.get('location');

    // Get the value of param2
    var param2Value = searchParams.get('sublocation');

    // Check if param1 has a value
    if (param1Value) {
      this.toggleTab(false, param1Value);
    }

    // Check if param2 has a value
    if (param2Value) {
      this.toggleSubTab(false, param2Value);
    }
  }

  deleteAddress(event) {
    event.preventDefault();
    const id = event.target.getAttribute("data-id");

    Shopify.postLink("/account/addresses/" + id, {
      parameters: { _method: "delete" },
    });

    setTimeout(() => {
      const currentUrl = new URL(window.location.href);
      window.location.href = currentUrl.href;
    }, 500);
  }

  toggleBack() {
    const menuTab = this.element.querySelector('.customer-account__menu');
    menuTab.style.display = "flex";
    this.accountHeader.style.display = "block";
    this.accountHeaderDivider.style.display = "block";

    if (window.location.search) {
      const newUrl = window.location.href.split('?')[0];
      window.history.replaceState(null, null, newUrl);
    }

    const visibleContent = this.element.querySelector('.account__content[aria-visible="true"]');

    if (visibleContent.id == "activeOrders" || visibleContent.id == "orderHistory") return;
    visibleContent.setAttribute('aria-visible', 'false');
    
  }

  toggleTab(event, paramValue) {
    let id = paramValue;
  
    if (event) {
      id = event.target.dataset.id;
    }
  
    const menuTab = this.element.querySelector('.customer-account__menu');
    const isDesktop = responsive.matchesBreakpoint('lap_and_up');
    const isPocket = responsive.matchesBreakpoint('pocket');
  
    if (isPocket) {
      this.accountHeader.style.display = "none";
      this.accountHeaderDivider.style.display = "none";
      menuTab.style.display = "none";
    }
  
    // Close the currently active tab
    const activeTab = this.element.querySelector('.customer-account__menu-tab[aria-expanded="true"]');
    if (activeTab) {
      activeTab.setAttribute('aria-expanded', 'false');
    }
  
    // Expand the clicked tab
    const newActiveTab = event ? event.target : this.element.querySelector(`[data-id="${id}"]`);
    if (newActiveTab) {
      newActiveTab.setAttribute('aria-expanded', 'true');
    }

    if(isDesktop) {
      const container       = this.element;
      const visibleContent  = container.querySelector('.account__content[aria-visible="true"]');
      const targetContent   = container.querySelector(`#${id}`);
    
      const showTarget = () => {
        // now that the old pane is gone, flip this one on
        targetContent.setAttribute('aria-visible', 'true');
        targetContent.setAttribute('aria-hidden',  'false');
      };
    
      if (visibleContent) {
        // listen for the end of *its* fade‐out
        const onHideEnd = e => {
          if (e.propertyName !== 'opacity') return;
          visibleContent.removeEventListener('transitionend', onHideEnd);
          visibleContent.setAttribute('aria-visible', 'false');
          showTarget();
        };
        visibleContent.addEventListener('transitionend', onHideEnd);
    
        // kick off the fade‐out
        visibleContent.setAttribute('aria-hidden', 'true');
       
      } else {
        showTarget();
      }
    } else {
      const targetContent = this.element.querySelector(`#${id}`);
  
      if (targetContent) {
          targetContent.setAttribute('aria-visible', 'true');
      } else {
        console.log(`No content found for ID: ${id}`);
      }
    }

    // Update URL without refreshing

    // Find the active subtab inside the orders page
    const activeSubTab = this.element.querySelector('.customer-account__toggle-tab[aria-expanded="true"]');
    const activeSubTabId = activeSubTab ? activeSubTab.getAttribute("data-id") : null;

    const currentUrl = window.location.href;
    let newUrl = null;

    // If the current tab id is the orders page update the url to the currently active subtab
    // Else just update the url to the currently opened tab
    if(id === 'contactOrders') {
      newUrl = currentUrl.split('?')[0] + `?location=${id}&sublocation=${activeSubTabId}`;
    } else {
      newUrl = currentUrl.split('?')[0] + `?location=${id}`;
    }

    window.history.pushState({ path: newUrl }, '', newUrl);
  }

  toggleSubTab(event, paramValue) {
    let id = paramValue;
  
    if (event) {
      id = event.target.dataset.id;
    }

    //Make old tab inactive
    const activeTab = this.element.querySelector('.customer-account__toggle-tab[aria-expanded="true"]');
    activeTab.setAttribute('aria-expanded', 'false');

      
    // Expand the clicked tab
    const newActiveTab = event ? event.target : this.element.querySelector(`[data-id="${id}"]`);
    if (newActiveTab) {
      newActiveTab.setAttribute('aria-expanded', 'true');
    }

    //Make old content inactive
    const visibleContent = this.element.querySelector('.customerAccount--ContentOrders[aria-visible="true"]');
    visibleContent.setAttribute('aria-visible', 'false');

    //Make new content active
    const newContent = this.element.querySelector(`#${id}`);
    if (newContent) {
      newContent.setAttribute('aria-visible', 'true');
    }
    // Update URL without refreshing
    const currentUrl = window.location.href;
    console.log(currentUrl);
    
    const url = new URL(currentUrl);
    url.searchParams.set('sublocation', id); // Add or update the sublocation parameter
    
    const newUrl = url.toString();
    console.log(newUrl);
    
    // Update the browser history without reloading the page
    window.history.pushState({ path: newUrl }, '', newUrl);
  }
}


customElements.define("account-component-inner", AccountComponent);